import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { StatusField, StatusFieldOption, StatusGroup } from 'api/tasks';
import { StatusIndicator } from 'components/molecules/status-indicator';

export const PopoverStatus = styled.div`
  display: flex;
  align-items: center;
  margin: var(--spacing-03) auto;
`;

export const StatusText = styled.p`
  margin: var(--spacing-01) var(--spacing-03);
  line-height: var(--spacing-05);
`;

export const getStatuses = (options: StatusFieldOption[]) => {
  const completedStatus = options.find(
    (o) => o.group === StatusGroup.Completed,
  );
  const inProgressStatus = options.find(
    (o) => o.group === StatusGroup.InProgress,
  );
  const totalStatus = options.find((o) => o.group === StatusGroup.Todo);

  return {
    completedStatus,
    inProgressStatus,
    totalStatus,
  };
};

export const PopoverContent = (
  {
    completed,
    inProgress,
    total,
  }: { completed: number; inProgress: number; total: number },
  statusField: StatusField,
): JSX.Element => {
  const { metaData } = statusField;

  const { completedStatus, inProgressStatus, totalStatus } = getStatuses(
    metaData?.options,
  );

  return (
    <>
      <PopoverStatus>
        <StatusIndicator status={completedStatus!} />
        <StatusText>
          <FormattedMessage
            id="projects.list.popover.current_phase.label"
            values={{
              taskCount: completed,
              status: completedStatus?.label,
            }}
          />
        </StatusText>
      </PopoverStatus>
      <PopoverStatus>
        <StatusIndicator status={inProgressStatus!} />
        <StatusText>
          <FormattedMessage
            id="projects.list.popover.current_phase.label"
            values={{
              taskCount: inProgress,
              status: inProgressStatus?.label,
            }}
          />
        </StatusText>
      </PopoverStatus>
      <PopoverStatus>
        <StatusIndicator status={totalStatus!} />
        <StatusText>
          <FormattedMessage
            id="projects.list.popover.current_phase.label"
            values={{ taskCount: total, status: 'Total' }}
          />
        </StatusText>
      </PopoverStatus>
    </>
  );
};
